/**
 * CommercialBoundary.tsx — MER Algo Footprints
 *
 * Phase-2 P2-D13 (D-P2AT-25). The single place in the route tree where the
 * commercial application begins. Everything that starts commercial runtimes —
 * AppShell and the workspaces — is nested beneath it; the account and recovery
 * surfaces (security, administration) are not.
 *
 * ── ACTIVE ────────────────────────────────────────────────────────────────────
 *
 * Prepared as a pass-through in IMPL-4 and activated by
 * G-P2-D13-ENFORCEMENT-ACTIVATION: it now renders SubscriberGate, so the
 * commercial shell mounts only for an account whose authoritative entitlement
 * state is 'entitled'. Everyone else sees a truthful access screen instead —
 * and, because AppShell never mounts for them, none of its commercial runtimes
 * start. This is UX and defence in depth; the server's commercial boundary is
 * the security control.
 */

import React from 'react';
import { SubscriberGate } from './SubscriberGate';

export function CommercialBoundary() {
  return <SubscriberGate />;
}
